angular.module("manager").factory("DriverService", ["$http", "ENV", function ($http, ENV) {

	/**
	 * API
	 */
	var api = {
		RESOURCE_URI: "/drivers/",
		addDriver: addDriver,
		deleteDriverById: deleteDriverById,
		editDriver: editDriver,
		editDriverActiveStatus: editDriverActiveStatus,
		getDriverById: getDriverById,
		getAllDriversByClient: getAllDriversByClient,
		importCsv: importCsv
	};


	/**
	 * Récupérer toutes les drivers pour une compagnie.
	 * @param driverId Identifiant de compagnie dont on souhaite récupérer les conducteurs.
	 * @returns {HttpPromise}
	 */
	function getAllDriversByClient() {
		return $http.get(ENV.API_URL + api.RESOURCE_URI);
	}

	/**
	 * Mettre à jour un driver.
	 * @param driver à metre à jour
	 * @returns {*|HttpPromise}
	 */
	function editDriver(driverId, driver) {
		return $http.put(ENV.API_URL + api.RESOURCE_URI + driverId, driver);
	}

	/**
	 * Mettre à jour un statu de conducteur
	 * @param driverId à metre à jour
	 * @param status le nouveau statut
	 * @returns {*|HttpPromise}
	 */
	function editDriverActiveStatus(driverId, status) {
		return $http.put(ENV.API_URL + api.RESOURCE_URI + driverId + "/activation", $.param({active: status}), {headers: {"Content-Type": "application/x-www-form-urlencoded"}});
	}


	/**
	 * Récupérer un drivers par son ID.
	 *
	 * @param id l'Id du driver à récupérer.
	 * @returns {*}
	 */
	function getDriverById(driverId) {
		return $http.get(ENV.API_URL + api.RESOURCE_URI + driverId);
	}

	/**
	 * Supprimer un driver.
	 *
	 * @param driver l'ID du driver à supprimer.
	 * @returns {HttpPromise|*|{display}}
	 */
	function deleteDriverById(driverId) {
		return $http.delete(ENV.API_URL + api.RESOURCE_URI + driverId);
	}

	/**
	 * POster un company vers le serveur.
	 * @param companyId L'ID de compagnie à laquelle associer le conducteur.
	 * @param driver le driver à ajouter.
	 * @returns {*|HttpPromise}
	 */
	function addDriver(driver) {
		return $http.post(ENV.API_URL + api.RESOURCE_URI, driver);
	}

	/**
	 * Import CSV
	 * @param driver
	 * @returns {HttpPromise}
	 */
	function importCsv(driver) {
		var fd = new FormData();
		fd.append("file", driver.file);
		fd.append("companyId", driver.company.id);

		return $http.post(ENV.API_URL + api.RESOURCE_URI + "import/csv", fd, {
			transformRequest: angular.identity,
			headers: {"Content-Type": undefined}
		});
	}

	return api;

}]);
